

/** Based on Bootstrap Modal availble on https://getbootstrap.com/docs/4.0/components/modal/
 *	<div class="modal" tabindex="-1" role="dialog">
 *		<div class="modal-dialog" role="document">
 *			<div class="modal-content">
 *				<div class="modal-header">
 *					<h5 class="modal-title">Modal title</h5>
 *					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
 *						<span aria-hidden="true">&times;</span>
 *					</button>
 *					</div>
 *				<div class="modal-body">
 *					<p>Modal body text goes here.</p>
 *				</div>
 *				<div class="modal-footer">
 *					<button type="button" class="btn btn-primary">Save changes</button>
 *					<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
 *				</div>
 *			</div>
 *		</div>
 *	</div>
 */
class Modal {

	defaultOptions(){
		return {
			//data
			'id': null,
			'title': '',
			'content': '',
			'container': window.document,

			//display configuration
			'titleMarkup': 'h5',
			'modalClass': '',
			'modalDialogClass': 'modal-dialog',
			'modalContentClass': 'modal-content',
			'modalHeaderClass': 'modal-header',
			'modalTitleClass': 'modal-title',
			'modalBodyClass': 'modal-body',
			'modalFooterClass': 'modal-footer',

			//advanced display configuration
			'verticalCentered': true,
			'modalSize': '',
			'staticModal': false,

			//
			'showFooter': false,
			'showHeader': true,


			//callbacks
			'onClose':function(event){},
			'onShown':function(event,modal){},
		};
	}

	constructor(options){
		this.settings = $.extend(this.defaultOptions(),options);

		// initialize attributes
		//this.$example = $('.class',this.$container);
		this.$modal = $('<div/>');

		if(this.settings.id === null){
			this.id = 'modalId' + (new Date()).getTime();
		}else{
			this.id = this.settings.id;
		}

		// bind events methods
		//this.onEvent = this.onEvent.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onShown = this.onShown.bind(this);

		// initalize object
		this.initialize();
	}

	initialize(){
		var self = this;
		this.$modal
		.attr('id',this.id)
		.addClass('modal fade')
		.addClass(this.settings.modalClass)
		.attr('tabindex','-1')
		.attr('role','dialog');
		this.getWrapper().append(this.$modal);

		this.$modalDialog = $('<div/>')
		.addClass('modal-dialog')
		.addClass(this.settings.modalDialogClass)
		.attr('role','document')
		.appendTo(this.$modal);

		switch(this.settings.modalSize){
			case 'xl':
			case 'xxl':
			case 'max':
				this.$modalDialog.addClass('modal-xl');
			break;

			case 'large':
			case 'lg':
				this.$modalDialog.addClass('modal-lg');
			break;

			case 'small':
			case 'sm':
				this.$modalDialog.addClass('modal-sm');
			break;

			default:
			//do nothing
			break;
		}

		if(this.settings.verticalCentered){
			this.$modalDialog.addClass('modal-dialog-centered');
		}

		this.$modalContent = $('<div/>')
		.addClass('modal-content')
		.addClass(this.settings.modalContentClass)
		.appendTo(this.$modalDialog);

		this.$modalHeader = $('<div/>')
		.addClass('modal-header')
		.addClass(this.settings.modalHeaderClass)
		.appendTo(this.$modalContent);

		if(!this.settings.showHeader){
			this.$modalHeader.hide();
		}

		this.$title = $('<'+this.settings.titleMarkup+'/>')
		.addClass('modal-title')
		.addClass(this.settings.modalTitleClass)
		.append(this.settings.title)
		.appendTo(this.$modalHeader);

		this.$btnClose = $('<button/>')
		.attr('type','button')
		.addClass('close')
		.addClass('btn btn-icon')
		.attr('data-dismiss','modal')
		.attr('aria-label','Close')
		.append(
			$('<span/>')
			.attr('aria-hidden','true')
			.append('&times;')
		)
		.on('click',function(event){
			self.dispose();
		})
		.appendTo(this.$modalHeader);


		this.$modalBody = $('<div/>')
		.addClass('modal-body')
		.addClass(this.settings.modalBodyClass)
		.append(this.settings.content)
		.appendTo(this.$modalContent);

		this.$modalFooter = $('<div/>')
		.addClass('modal-footer')
		.addClass(this.settings.modalFooterClass)
		.appendTo(this.$modalContent);

		if(!this.settings.showFooter){
			this.$modalFooter.hide();
		}

		this.$modal.on('hidden.bs.modal',this.onClose);
		this.$modal.on('shown.bs.modal',this.onShown);
	
		this.$modal.modal({
			'show': false,
			'focus': false,
			'keyboard': this.settings.staticModal ? false : true,
			'backdrop': this.settings.staticModal ? 'static' : true,
		});

	}

	onDOM(){
		return this;
	}

	getWrapper(){
		if($('#outofscope',this.settings.container).length <= 0){
			$('body').append($('<div/>').attr('id','outofscope'));
		}
		return $('#outofscope',this.settings.container);
	}

	onShown(event){
		if(this.settings.onShown){
			this.settings.onShown(event,this);
		}
	}

	onClose(event){
		if(this.settings.onClose){
			this.settings.onClose(event);
		}
	}

	show(){
		this.$modal.modal('show');
		return this;
	}

	hide(){
		this.$modal.modal('hide');
		return this;
	}

	dispose(){
		var self = this;
		this.hide();
		this.$modal.remove();

		$('.modal-backdrop').remove();
    	$('body').removeClass('modal-open');
    
		return this;
	}

	setTitle($title){
		this.$title.html($title);
		return this;
	}

	setContent($content){
		this.$modalContent.html($content);
		return this;

	}

	setBodyContent($content){
		this.$modalBody.html($content);
		return this;
	}

	setHeaderContent($content){
		this.$modalHeader.html($content);
		return this;
	}

	setFooterContent($content){
		this.$modalFooter.html($content);
		return this;
	}

	getHeight(){
		return this.$modal.height();
	}

	getWidth(){
		return this.$modal.width();
	}

}

module.exports = Modal;